import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { USER_ROLE_SUNROOM_CLUB } from 'common/userRoles';

import { SR_API_ACTION_SUBMIT_SUNROOM_CLUB_QUESTIONNAIRE } from 'api/actionTypes';

import { SCREEN_ID_JOIN_SUNROOM_CLUB_QUESTIONNAIRE } from 'client/constants/screenIds';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withApiState from 'client/helpers/withApiState';

import postWithState from 'client/actions/postWithState';

import SrLink from 'client/components/SrLink/SrLink';
import SrFormikField from 'client/components/SrFormikField';
import ButtonDeprecated from 'client/components/ButtonDeprecated';
import Navbar from 'client/components/Navbar';

const formFields = [
  {
    id: 'monthlyIncome',
    title: "What's your monthly income before taxes?",
    label:
      'How much do you and your roommates make each month, combined. ' +
      'Before taxes are taken out of your paystub.',
    properties: {
      placeholder: '2700',
    },
    validations: ['required'],
    type: 'number',
  },
  {
    id: 'creditScore',
    title: 'Whats your credit score?',
    label: 'Your best estimate.',
    properties: {
      placeholder: '750',
    },
    validations: ['required'],
    type: 'number',
  },
  {
    id: 'evictionsOrBrokenLeases',
    title: 'Have you ever had evictions or broken leases?',
    validations: ['required'],
    type: 'yes_no',
  },
  {
    id: 'convitedOfCrime',
    title: 'Have you ever been convicted of a misdemeanor or felony?',
    validations: ['required'],
    type: 'yes_no',
  },
];

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_SUNROOM_CLUB],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withApiState({
  submitSunroomClubQuestionnaireApiState: {
    action: SR_API_ACTION_SUBMIT_SUNROOM_CLUB_QUESTIONNAIRE,
  },
})
@withScreenId(SCREEN_ID_JOIN_SUNROOM_CLUB_QUESTIONNAIRE)
@withScrollToTop
class SunroomClubQualificationFormPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    submitSunroomClubQuestionnaireApiState: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0,
      formValues: {},
    };
  }

  _onNextButtonClick = (currentStepValues) => {
    const { currentStep, formValues } = this.state;
    const newFormValues = {
      ...formValues,
      ...currentStepValues,
    };
    if (currentStep === formFields.length - 1) {
      this._onSubmit(newFormValues);
    } else {
      this.setState({
        currentStep: currentStep + 1,
        formValues: newFormValues,
      });
    }
  };

  _onSubmit = (formValues) => {
    const { dispatch, history } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_SUBMIT_SUNROOM_CLUB_QUESTIONNAIRE,
      payload: formValues,
    }).then(() => {
      history.push('/join-sunroom-club/thank-you');
    });
  };

  render() {
    const { submitSunroomClubQuestionnaireApiState } = this.props;
    const { currentStep } = this.state;
    const formField = formFields[currentStep];
    const progressPercentage = (currentStep / formFields.length) * 100;

    return (
      <div className="formProgressive">
        <div className="progressBarContainer">
          <div className="progressBar" style={{ width: `${progressPercentage}%` }} />
        </div>
        <Navbar leftButton={<SrLink to="/join-sunroom-club/paid" />} />
        <div className="contentContainer">
          <Formik
            enableReinitialize
            onSubmit={this._onNextButtonClick}
            initialValues={createInitialValues({ formFields: [formField] })}
            validate={createFormValidationFn([formField])}
          >
            {(formikBag) => (
              <Form>
                <SrFormikField formField={formField} formikBag={formikBag} />
                <ButtonDeprecated
                  type="submit"
                  className="button next"
                  disabled={submitSunroomClubQuestionnaireApiState.inProgress}
                >
                  {submitSunroomClubQuestionnaireApiState.inProgress ? 'please wait...' : 'next'}
                </ButtonDeprecated>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    );
  }
}

SunroomClubQualificationFormPage.displayName = 'SunroomClubQualificationFormPage';

export default SunroomClubQualificationFormPage;
